const phoneNumberTogglers = document.querySelectorAll('.js-phone-number-toggler');

if (phoneNumberTogglers.length > 0) {
    [].forEach.call(phoneNumberTogglers, toggler => {
        toggler.addEventListener('click', () => {
            toggler.parentElement.classList.add('visible');
        });
    });
}